module.exports = __webpack_public_path__ + "img/boxsucces.860e3cea.png";